import {
  SafeGetArgs,
  safeGet,
  safeSave,
  getOpenerSessionData
} from './storage';
import logger from '../log';
import { v4 } from 'uuid';

const log = logger.getLogger(__filename);
export const KEY_STORED_DATA = 'ksdk::common::data';

export interface StoredData {
  contentId?: string;
  playGuid: string;
  start: number;
}

const defaultArgs: SafeGetArgs<StoredData | null> = {
  which: 'sessionStorage',
  default: null,
  key: KEY_STORED_DATA,
  log
};

export function localData(reset: boolean, contentId?: string): StoredData {
  if (reset) {
    return generateStoredData(contentId);
  }
  return getStoredData(contentId) ?? generateStoredData(contentId);
}

// Visible for testing
export function getStoredData(contentId?: string): StoredData | null {
  const data = safeGet(defaultArgs);
  const openerData = getOpenerSessionData(KEY_STORED_DATA) as StoredData;
  const { playGuid: parentGuid } = openerData ?? {};
  if (data?.playGuid === parentGuid || !data?.playGuid || !data?.start) {
    return null;
  }
  // Update the data if we have data w/o contentId and we have a contentId
  if (!!contentId && !data.contentId) {
    data.contentId = contentId;
    safeSave({ ...defaultArgs, data });
  }
  return !contentId || contentId === data?.contentId ? data : null;
}

// Visible for testing
export function generateStoredData(contentId?: string): StoredData {
  const data: StoredData = { playGuid: v4(), start: Date.now() };
  if (contentId) {
    data.contentId = contentId;
  }
  safeSave({ ...defaultArgs, data });
  return data;
}
